import { newToolFilterOAuthMcp } from "../oauth.ts";

export const fathomMcpResolver = newToolFilterOAuthMcp({
  iconUrl:
    "https://cdn.prod.website-files.com/6899da9beccbdbe92be49b5d/6a4282cf896cae98018bfa8c_fathom_favicon.png",
  url: "https://api.fathom.ai/mcp",
  label: "Fathom",
});
